import type { FC } from 'react';

import type { GameV1 } from '@/api/games';
import { GamesGridStatic } from '@/components/GamesGrid';
import type { PerChunk } from '@/components/GamesGrid/helpers';
import type { GridOptions } from '@/components/GamesGrid/styled';
import { useGetCommonStore } from '@/store';

export const getGridOptions = (isMobileDevice: boolean) => ({
  columns: 4,
  columnsTablet: 4,
  columnsMobile: 4,
  columnsMobileS: 3,
  columnGap: isMobileDevice ? 16 : 12,
  rowGap: isMobileDevice ? 16 : 8,
});

interface GamesGridBlockStaticProps {
  games: GameV1[];
  loading: boolean;
  perChunkObj?: PerChunk;
  gridOptions?: GridOptions;
  plugGray?: boolean;
  totalCount?: number;
  isSearchModal?: boolean;
  onShowMoreButtonClick?: () => void;
  onPlayClick?: (game: GameV1) => void;
  onDemoClick?: (game: GameV1) => void;
}

export const GamesGridBlockStatic: FC<GamesGridBlockStaticProps> = ({
  games,
  perChunkObj,
  loading,
  gridOptions,
  plugGray,
  totalCount,
  isSearchModal,
  onShowMoreButtonClick,
  onPlayClick,
  onDemoClick,
}) => {
  const useCommonStore = useGetCommonStore();

  const isMobileDevice = useCommonStore.use.isMobileDevice();
  return (
    <GamesGridStatic
      games={games}
      gridOptions={gridOptions || getGridOptions(isMobileDevice)}
      isSearchModal={isSearchModal}
      loading={loading}
      onDemoClick={onDemoClick}
      onPlayClick={onPlayClick}
      onShowMoreButtonClick={onShowMoreButtonClick}
      perChunkObj={perChunkObj}
      plugGray={plugGray || isMobileDevice}
      totalCount={totalCount}
    />
  );
};
